<template>

  <svg
    t="1639130694709"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M230.75 624.5v200.94374971L620.07499971 624.5H230.75zM155.75000029 948.55625V549.50000029h773.17499971L155.75000029 948.55625zM928.925 474.49999971H155.75000029V75.44375L928.925 474.49999971z" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconFlipV',
} as DefineComponent
</script>